/**
 * Vereinswappen mit Platzhalter-Fallback (generisch, keine Marken-Assets).
 * Rundung/Größe kommen über `className` (z. B. `size-6 rounded-md`).
 */
export function ClubLogo({
	src,
	name,
	className = 'size-6 rounded-md',
}: {
	src: string | null
	name: string
	className?: string
}) {
	if (src) {
		return (
			<img
				src={src}
				alt=""
				loading="lazy"
				className={`${className} shrink-0 bg-white/5 object-contain`}
			/>
		)
	}
	return (
		<span
			aria-hidden="true"
			className={`${className} bg-muted text-muted-foreground grid shrink-0 place-items-center text-[10px] font-semibold`}
		>
			{name.slice(0, 1).toUpperCase()}
		</span>
	)
}
